import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordPage } from "@/features/users/forgotPassword";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/forgot-password")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Forgot Password");

  return <ForgotPasswordPage />;
}
